import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Logger } from 'angular2-logger/core';

import { SharedService } from '../../../shared/shared.service';
import { UserService } from '../user.service';
import { NgxSpinnerService } from 'ngx-spinner';

//  Jquery imports
declare var jquery: any;
declare var $: any;

@Component({
	selector: 'app-user-new',
	templateUrl: './user-new.component.html',
	styleUrls: ['./user-new.component.scss']
})

export class UserNewComponent implements OnInit {
	//public load: boolean;
	public form: FormGroup;
	//public m_load: boolean;
	public schedule_list: any = [];
	public shop_list: any = [];
	public schedule: any = {};
	public shop: any = {};
	public day_helper = { 1: 'monday', 2: 'tuesday', 3: 'wednesday', 4: 'thursday', 5: 'friday', 6: 'saturday', 7: 'sunday' };

	public status_list: any = [];

	constructor(
		private _userService: UserService,
		private _sharedService: SharedService,
		private _router: Router,
		public toastr: ToastsManager,
		private logger: Logger,
		private fb: FormBuilder,
		private spinner: NgxSpinnerService
	) {

		this.schedule.monday = [];
		this.schedule.tuesday = [];
		this.schedule.wednesday = [];
		this.schedule.thursday = [];
		this.schedule.friday = [];
		this.schedule.saturday = [];
		this.schedule.sunday = [];

		this.form = this.fb.group({
			firstname: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(60)]],
			lastname: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(60)]],
			role: ['', [Validators.required]],
			suspended: ['', [Validators.required]],
			email: ['', [Validators.required, Validators.pattern('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$')]],
			schedule: ['', [Validators.required]],
			shop:[]
		});

	}


	ngOnInit() {  // initializes the schedule list.
		//this.load = true;
		this.spinner.show();

		let data = {
			auth_token: this._sharedService.getCookie("auth_token"),
			type: 1, //Solo los horarios regulares
            view : 'user'
		};

		this._userService.getScheduleListByType(data).subscribe(
			data => {
				//this.load = false;
				this.spinner.hide();
				if (data.status) { //success
					this.schedule_list = data.data; // schedule list
				} else { // API error
					this.toastr.error(data.message, 'Error');
				}

			},
			error => { //server error
				//this.load = false;
				this.spinner.hide();
				this.toastr.error('Ha ocurrido un error, inténtalo de nuevo', 'Error');
				this.logger.log(error);
			}
		);

		this._userService.getShop(data).subscribe(
			data => {
				let valuei= 0;
				for (let i = 0; i < data.data.length; i++) {
					this.shop_list[i] = 
					{'id': data.data[i].id, 'itemName':data.data[i].fullname};
					valuei = i;  
				}
				console.log(data);

			},
			error => { //server error
				//this.load = false;
				this.spinner.hide();
				this.toastr.error('Ha ocurrido un error, inténtalo de nuevo', 'Error');
				this.logger.log(error);
			}
		);
	}


	onNew() {
		//this.load = true;
		this.spinner.show();
		this.form.value.auth_token = this._sharedService.getCookie('auth_token');
		this.form.value.suspended = parseInt(this.form.value.suspended);
		this.form.value.role = parseInt(this.form.value.role);
		this.form.value.schedule = parseInt(this.form.value.schedule);
		this.form.value.shop = parseInt(this.form.value.shop);
		//this.form.valustatus_conetion = parseInt(this.form.valustatus_conetion);

		this.logger.log(this.form.value);
		this._userService.newuser(this.form.value).subscribe( 
			data => {
				console.log(data.status);
				if (data.status) {
					this.logger.log(data.status);
					let param = {
						auth_token: this._sharedService.getCookie('auth_token'),
						user_id: data.data.id,
						schedule_ids: [this.form.value.schedule]
					}
					this._userService.saveUserSchedule(param).subscribe(
						res => {
							this.logger.log(res.status);
							console.log("Se asocio el horario al usuario correctamente");
						}, error => {
							this.toastr.error(data.message, 'Error');
						}
					);
					this.toastr.success('El nuevo usuario ha sido creado!', '¡Éxito!');
					this.onCancel();
					// location.href = 'http://localhost:4200/#/admin/users/list';
				} else {
					this.toastr.error(data.message, 'Error');
				}
				//this.load = false;
				this.spinner.hide();
			},
			error => {
				if (error.status === 422) {
					this.toastr.error('El correo que ingresó, ya ha sido registrado', ' Error');
				} else {
					this.toastr.error('Problemas con el envío del correo', ' Error');
				}
				this.logger.log(error);
				//this.load = false;
				this.spinner.hide();
			}
		);
	}

	onCancel() {
		return this._router.navigate(['./admin/users/list']);
	}

	onDetails(id: number) {

		$('#Details').modal('toggle'); // open modal

		//this.m_load = true;
		this.spinner.show();

		let data = {
			auth_token: this._sharedService.getCookie('auth_token'),
			id: id
		}

		this._userService.getSchedule(data).subscribe(
			data => {
				if (data.status) {
					this.logger.log(data.data);
					this.logger.log('schedule data received');
					this.schedule.name = data.data.name

					for (let i = 0; i < data.data.schedules.length; i++) {
						let aux_day = this.day_helper[data.data.schedules[i].day_week];
						this.schedule[aux_day] = data.data.schedules[i].shift;
					}

				} else {
					this.toastr.error(data.message, 'Error');
				}

				//this.m_load = false;
				this.spinner.hide();
			},
			error => {
				this.toastr.error('Ha ocurrido un error, inténtalo de nuevo.', 'Error');
				//this.m_load = false;
				this.spinner.hide();
				this.logger.log(error);
			}
		);

	}

}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/user/user-new/user-new.component.ts